import styled from "styled-components";

interface TextAreaWrapperProps {
  $disabled?: boolean;
  $labelColor?: string;
  $width?: string;
  $isReadonly?: boolean;
}

export const TextAreaWrapper = styled.div<TextAreaWrapperProps>`
  display: flex;
  flex-direction: column;
  position: relative;
  width: ${(props) => props.$width ?? "100%"};
  border: 1px solid ${(props) => (props.$disabled ? "#ececec" : "#E9E9E9")};
  border-radius: 8px;
  padding-bottom: 8px; /* room for the char count */

  &:hover {
    border-color: ${(props) => (props.$isReadonly ? "#E9E9E9" : "#a3a3a3")};
  }

  &:focus-within {
    border: 1px solid ${(props) => (props.$isReadonly ? "#E9E9E9" : "#000000")};
  }

  &.error {
    border: 1px solid #f9123b;
  }
  &.error p {
    color: #f9123b;
  }

  & p {
    background-color: ${(props) => props.$labelColor || "#fff"};
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1),
      opacity 150ms cubic-bezier(0.4, 0, 0.2, 1);

    &.input-label {
      font-family: "Inter";
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #8d8d8d;
      position: absolute;
      top: 14px;
      left: 14px;
      margin: 0;
      padding: 0;
      pointer-events: none;

      &.top {
        height: max-content;
        font-size: 12px;
        line-height: 16px;
        color: #a3a3a3;
        top: 0;
        transform: translate(-6px, -8px);
        padding: 0 2px;
        z-index: 1;
      }
    }
  }
`;

interface TextAreaFieldProps {
  $disabled?: boolean;
  $isReadonly?: boolean;
}

export const TextAreaField = styled.textarea<TextAreaFieldProps>`
  font-family: "Inter";
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  width: 100%;
  box-sizing: border-box;
  background-color: transparent;
  border: none;
  outline: none;
  resize: vertical;
  padding: 12px 14px 4px;
  color: ${(props) => (props.$disabled ? "#757575" : "#000000")};
  cursor: ${(props) => (props.$isReadonly ? "default" : "auto")};
  border-radius: 8px;

  &::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #8d8d8d;
  }
`;

export const CharCount = styled.span`
  font-family: "Inter";
  font-size: 12px;
  line-height: 16px;
  color: #a3a3a3;
  text-align: right;
  padding-right: 14px;
  pointer-events: none;
`;